import Repository from "./Repository";
const bestSeller = "/best-seller";

export default {
  getbestSeller(payload) {
    return Repository.get(`${bestSeller}/${payload}`);
  }
};
